import store_configs from '@/store/mods/parametres/config'

export default {
    name: 'manage-coupon-authorized-user',
    components: {},
    props: [],
    data() {
        return {
            admin_users: [],
            usr_is_loading: false,
            usr_is_empty: true,
            filter_user: '',
            filtered_users: [],

            one_is_checked: [],
            choice_is_empty: false,
            save_loading: false,
            has_error: false
        }
    },

    watch: {
        filter_user() {
            this.filterUser()
        }
    },

    computed: {

    },

    mounted() {
        this.getAdminUsers()
    },

    methods: {
        getAdminUsers() {
            this.usr_is_loading = true
            store_configs.getAdminUsers().then((response) => {
                this.admin_users = response
                if (response.length == 0) {
                    this.usr_is_empty = true
                } else {
                    this.usr_is_empty = false
                    this.filtered_users = response

                    this.admin_users.forEach(user => {
                        if (user.can_authorize_coupon == 1) {
                            this.one_is_checked.push(user.id)
                        }
                    });
                }
                this.usr_is_loading = false
            })
        },

        filterUser() {
            this.filtered_users = [];

            if (this.filter_user == '') {
                this.filtered_users = this.admin_users
            } else {
                this.admin_users.forEach(user => {
                    let cleaned_user = this.removeAccents(user.name)
                    let cleaned_filter = this.removeAccents(this.filter_user)

                    if (cleaned_user.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_users.push(user)
                    }
                });
            }
        },

        submit() {
            this.has_error = false
            let data = {
                users_id: this.one_is_checked
            }

            this.save_loading = true
            this.$store.dispatch('saveCouponAuthorizedUsers', data).then((response) => {
                if (response.success) {
                    this.$emit('emitRefreshAuthorizedUsers')
                    this.$refs.authorized_user.click()

                    this.successToast('Enregistrement effectué avec succès.')
                } else {
                    this.has_error = true
                }

                this.save_loading = false
            }).catch(() => {
                this.has_error = true
                this.save_loading = false
            })
        }
    }
}